var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgVideoOff = function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.219 5h-.021L3.113 1.915a.847.847 0 10-1.198 1.198L3.802 5h-.469c-.92 0-1.666.746-1.666 1.667v6.666c0 .92.746 1.667 1.666 1.667H12.5c.367 0 .707-.119.982-.32l3.405 3.405a.847.847 0 101.198-1.198l-3.918-3.918v-.021L12.5 11.28v.021L7.865 6.667h.02L6.22 5zM12.5 8.885V6.667h-2.219L8.615 5H12.5c.92 0 1.667.746 1.667 1.667v.714l2.92-1.669a.833.833 0 011.246.724v7.128a.833.833 0 01-.427.728l-3.396-3.396 2.157 1.232V7.872l-2.5 1.428v1.252L12.5 8.885zM3.333 6.667H5.47l6.667 6.666H3.333V6.667z"
  })));
};
export default SvgVideoOff;